import React, { useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

function Aboutus() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}>
      <section className="inner-banner-wrap" >
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">About Us</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="about-page-section">
        <div className="about-inner-page">
          <div className="container">
            <div className="about-head-wrap">
              <div className="row align-items-center">
                <div className="col-md-6 col-lg-7">
                  <div className="section-head" >
                    <div className="title-divider" />
                    <h2 className="section-title" data-aos="fade-up">
                      Hello! Our Business Has Been Present For over 5 Years In The{" "}
                      <span className="primary-color">Market</span>
                    </h2>
                    <p>
                      We have been a leader in the industry for over 5 years, providing top-notch products and services that meet the ever-evolving needs of the market.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-5 " data-aos="fade-up-left">
                  <div className="testimonial-inner">
                    <div className="testimonial-single">
                      <p>
                        <em>
                          “   100+ Successful Projects Delivered ”
                        </em> <br/> <br/>
                        <em>
                          “   Clients Across 10+ Countries  ”
                        </em><br/> <br/>
                        <em>
                          “   Recognized for Excellence in Service  ”
                        </em>
                      </p>
                      <div className="testimonial-content-wrap d-none">
                        <figure className="testi-img">
                          <img src="assets/images/img11.jpg" alt="William Scott" />
                        </figure>
                        <div className="testi-content">
                          <h4>William Scott</h4>
                          <span>CEO, Manager</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="iconbox-container d-flex flex-wrap">
              <div className="iconbox-item-3 d-flex flex-wrap" data-aos="fade-left" data-aos-delay="100">
                <div className="iconbox-border d-flex align-items-center">
                  <div className="iconbox-icon primary-bg">
                    <i aria-hidden="true" className="icon icon-medal1" />
                  </div>
                  <div className="iconbox-content">
                    <h4>Award winning</h4>
                    <p>We are proud to have received numerous awards for our commitment to quality and service excellence.</p>
                  </div>
                </div>
              </div>
              <div className="iconbox-item-3 d-flex flex-wrap" data-aos="fade-left" data-aos-delay="300">
                <div className="iconbox-border d-flex align-items-center">
                  <div className="iconbox-icon primary-bg">
                    <i aria-hidden="true" className="icon icon-money-bag" />
                  </div>
                  <div className="iconbox-content">
                    <h4>Well Allowances</h4>
                    <p>We offer competitive allowances and benefits to ensure the well-being satisfaction of our team members.</p>
                  </div>
                </div>
              </div>
              <div className="iconbox-item-3 d-flex flex-wrap" data-aos="fade-left" data-aos-delay="400">
                <div className="iconbox-border d-flex align-items-center">
                  <div className="iconbox-icon primary-bg">
                    <i aria-hidden="true" className="icon icon-chart2" />
                  </div>
                  <div className="iconbox-content">
                    <h4>Career Development</h4>
                    <p>We invest in our team's growth through ongoing training, mentorship, and career development opportunities.</p>
                  </div>
                </div>
              </div>
            </div>
            <div
            className="about-video-banner d-flex align-items-center justify-content-center mt-5 vid"
            style={{
              backgroundImage: "url(assets/images/img14.jpg)",
              minHeight: "550px",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "10px",
            }}
          >
            {/* <div className="video-button">
              <button
                onClick={() => setIsVideoOpen(true)}
                style={{
                  background: "rgba(0,0,0,0.6)",
                  border: "none",
                  borderRadius: "50%",
                  width: "70px",
                  height: "70px",
                  color: "#fff",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              >
                <i aria-hidden="true" className="icon icon-play1" />
              </button>
            </div> */}
            <div className="video-button">
              <a id="video-container"  onClick={() => setIsVideoOpen(true)}
                >
                <i aria-hidden="true" className="icon icon-play1" />
              </a>
            </div>
          </div>
            <div className="process-count-wrap mb-4">
              <div className="row">
                <div className="col-md-6" data-aos="fade-right" data-aos-delay="250">
                  <div className="process-count-item">
                    <span className="process-number">
                      <i className="fas fa-comments" /> {/* advice icon */}
                    </span>
                    <div className="process-content">
                      <h4>Get Professional Advice</h4>
                      <p>
                        Our experts provide tailored advice to help you make informed decisions about your future.
                      </p>
                    </div>
                  </div>

                </div>
                <div className="col-md-6" data-aos="fade-left" data-aos-delay="300">
                  <div className="process-count-item">
                    <span className="process-number">
                      <i className="fas fa-user-tie" />
                    </span>
                    <div className="process-content">
                      <h4>Trusted Best Professionals</h4>
                      <p>
                        Our team consists of highly skilled professionals who are committed to achieving excellence.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="about-inner-process bg-light-grey d-none">
          <div className="container">
            <div className="section-head text-center">
              <div className="row">
                <div className="col-lg-8 offset-lg-2">
                  <div className="title-divider" />
                  <h2 className="section-title" data-aos="fade-up">
                    Our Flawless <span className="primary-color">Process</span>
                  </h2>
                  <p>
                    We have developed a streamlined process that ensures efficiency and quality at every stage of the project.
                  </p>
                </div>
              </div>
            </div>
            <div className="support-inner text-center" data-aos="fade-up-right" data-aos-delay="200">
              <div className="row">
                <div className="col-md-3 col-sm-6">
                  <div className="support-icon-item">
                    <a href="/">
                      <i aria-hidden="true" className="icon icon-page_search" />
                      <h4>Research</h4>
                    </a>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="support-icon-item">
                    <i aria-hidden="true" className="icon icon-atomic" />
                    <h4>Develop</h4>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="support-icon-item">
                    <i aria-hidden="true" className="icon icon-settings1" />
                    <h4>Testing</h4>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="support-icon-item">
                    <i aria-hidden="true" className="icon icon-checked1" />
                    <h4>Launch</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isVideoOpen && (
        <div
          className="video-modal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "900px",
              width: "90%",
              background: "#000",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <video width="100%" controls >
              <source src="/assets/images/Metting.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* Close Button */}
            <a
              onClick={() => setIsVideoOpen(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "5px",
                background: "transparent",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                cursor: "pointer",
                fontSize: "20px",
                fontWeight:"bold",
                // position: "absolute",
                // top: "10px",
                // right: "10px",
                // background: "transparent",
                // color: "#fff",
                // cursor: "pointer",
                // fontSize: "22px",
              }}
            >
              ✕
            </a>
          </div>
        </div>
      )}



    </div>
  )
}

export default Aboutus
